/** Modal que muestra las últimas órdenes de trabajo de un equipo. */
import React from 'react';

const TIPO_MANTENIMIENTO_ICONS = {
  preventivo: 'calendar-check',
  correctivo: 'wrench',
  predictivo: 'chart-line',
  emergencia: 'exclamation-triangle'
};

const OT_ESTADO_BADGE = {
  completado: 'success',
  en_progreso: 'warning',
};

/**
 * Modal que lista las últimas órdenes de trabajo asociadas a un equipo.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Si el modal está visible
 * @param {Object|null} props.equipo - Equipo cuyas OT se muestran
 * @param {Array} props.ordenesTrabajo - Lista de órdenes de trabajo
 * @param {boolean} props.loading - Estado de carga
 * @param {Function} props.onClose - Callback al cerrar
 * @returns {JSX.Element|null}
 */
function OrdenesTrabajoModal({ isOpen, equipo, ordenesTrabajo, loading, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-container modal-container-wide" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">
            Órdenes de Trabajo - {equipo?.codigo}
          </h3>
          <button className="modal-close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body" style={{ maxHeight: '500px', overflowY: 'auto' }}>
          {loading ? (
            <div className="text-center">
              <i className="fas fa-spinner fa-spin"></i> Cargando...
            </div>
          ) : ordenesTrabajo.length === 0 ? (
            <div className="text-center text-muted">
              No hay órdenes de trabajo registradas
            </div>
          ) : (
            <div className="ordenes-trabajo-list">
              {ordenesTrabajo.map(m => {
                const iconName = TIPO_MANTENIMIENTO_ICONS[m.tipo_mantenimiento?.codigo] || 'wrench';
                const badgeVariant = OT_ESTADO_BADGE[m.estado] || 'secondary';

                return (
                  <div key={m.id} className="orden-trabajo-item">
                    <div className="orden-trabajo-icon">
                      <i className={`fas fa-${iconName}`}></i>
                    </div>
                    <div className="orden-trabajo-info">
                      <strong>{m.tipo_mantenimiento?.nombre || 'Orden de Trabajo'}</strong>
                      <p>{m.descripcion}</p>
                      <small>
                        {new Date(m.fecha_ejecucion).toLocaleDateString('es-CL')}
                      </small>
                    </div>
                    <span className={`badge badge-${badgeVariant}`}>
                      {m.estado}
                    </span>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <a
            href={`/ordenes-trabajo?equipo_id=${equipo?.id}`}
            className="btn btn-primary"
          >
            Ver Todos
          </a>
        </div>
      </div>
    </div>
  );
}

export default OrdenesTrabajoModal;
